import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import store from '@/store'

import axios from 'axios';
import './assets/styles/common.css'

import common from './assets/js/common';
Vue.prototype.$common = common;

Vue.prototype.$bus= new Vue()
Vue.prototype.$https=axios;

Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
